var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('p',[_vm._v("A page for this Url does not exist.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }